// extracted by mini-css-extract-plugin
export default {"expertiseContainer":"Expertise_expertiseContainer__SuGrJ","contentWrapper":"Expertise_contentWrapper__wfOIb","cardWrapper":"Expertise_cardWrapper__I2zk0"};